import { lightTheme } from '@sketch/global-styles';
export { lightTheme as default } from '@sketch/global-styles';

const errorStyles = `
  color: ${lightTheme.colors.state.negative.A};
  font-size: ${lightTheme.fontSizes.C};
`;

export { errorStyles };
